import HTTP from '@/config/axios-config-erp'

const SrvOrdenesCompra = {
    // LISTA DE VALORES
    getOrdenesCompraPendientes(payload) {
        return HTTP.post(`/wscomun/portalinformes/getOrdenesCompraPendientes`, payload).then(respuesta => {
            if (respuesta.status === 200) {
                return respuesta
            } else {
                console.error(respuesta)
                return respuesta
            }
        }).catch(error => {
            return error
        })
    },
    getDetalleOrdenCompraPendiente(payload) {
        return HTTP.post(`/wscomun/portalinformes/getDetalleOrdenCompraPendiente`, payload).then(respuesta => {
            if (respuesta.status === 200) {
                return respuesta
            } else {
                console.error(respuesta)
                return respuesta
            }
        }).catch(error => {
            return error
        })
    },
    generarOcPedido(payload) {
        return HTTP.post(`/wscomun/portalinformes/generarOcPedido`, payload).then(respuesta => {
            if (respuesta.status === 200) {
                return respuesta
            } else {
                console.error(respuesta)
                return respuesta
            }
        }).catch(error => {
            return error
        })
    }
}

export default SrvOrdenesCompra



// WEBPACK FOOTER //
// ./src/services/srv-ordenes-compra.js